import { has } from 'lodash';
import {
  INIT_VIDEO_STREAM_SUCCESS,
  INIT_SCREEN_STREAM_SUCCESS,
  STOP_VIDEO_STREAM,
  STOP_SCREEN_STREAM,
  SET_DEVICE_CONTROLLER,
  SET_MEETING_SESSION,
  STREAM_ERROR,
  END_MEETING_SESSION,
  INIT_DEVICES_SUCCESS,
  SET_SELECTED_DEVICE,
  OPEN_MEDIA_RECOVERY_MODAL,
  CLOSE_MEDIA_RECOVERY_MODAL,
  SET_SCREEN_SHARE_INITIATED,
  CLEAR_SCREEN_SHARE_INITIATED,
  SET_MEDIA_SHARE_COMPLETED,
} from '../actions/AssesmentRecordingActions';

const initialState = {
  videoStream: null,
  screenStream: null,
  deviceController: null,
  meetingSession: null,
  error: null,
  hasVideo: false,
  hasAudio: false,
  hasScreen: false,
  videoInputs: [],
  audioInputs: [],
  audioOutputs: [],
  selectedVideoInput: null,
  selectedAudioInput: null,
  selectedAudioOutput: null,

  recoveryModalOpen: false,
  recoveryReason: 'unknown',
  screenShareInitiated: null,
  mediaShareCompleted: false,
};

export default function streamReducer(state = initialState, action) {
  switch (action.type) {
    case INIT_DEVICES_SUCCESS: {
      const { videoInputs, audioInputs, audioOutputs } = action.payload;
      return {
        ...state,
        videoInputs,
        audioInputs,
        audioOutputs,
        selectedVideoInput: videoInputs[0]?.deviceId || null,
        selectedAudioInput: audioInputs[0]?.deviceId || null,
        selectedAudioOutput: audioOutputs[0]?.deviceId || null,
      };
    }

    case SET_SELECTED_DEVICE: {
      const { kind, deviceId } = action.payload;
      if (kind === 'video') {
        return { ...state, selectedVideoInput: deviceId };
      } else if (kind === 'audio') {
        return { ...state, selectedAudioInput: deviceId };
      } else if (kind === 'speaker') {
        return { ...state, selectedAudioOutput: deviceId };
      }
      return state;
    }

    case INIT_VIDEO_STREAM_SUCCESS:
      return {
        ...state,
        videoStream: action.payload,
        hasVideo: true,
        hasAudio: true,
        error: null,
      };
    case INIT_SCREEN_STREAM_SUCCESS:
      return {
        ...state,
        screenStream: action.payload,
        hasScreen: true,
        error: null,
      };
    case STOP_VIDEO_STREAM:
      return {
        ...state,
        videoStream: null,
        hasVideo: false,
      };
    case STOP_SCREEN_STREAM:
      return {
        ...state,
        screenStream: null,
        hasScreen: false,
      };
    case SET_DEVICE_CONTROLLER:
      return {
        ...state,
        deviceController: action.payload,
      };
    case SET_MEETING_SESSION:
      return {
        ...state,
        meetingSession: action.payload,
      };
    case STREAM_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case END_MEETING_SESSION:
      return {
        ...initialState,
      };
    case OPEN_MEDIA_RECOVERY_MODAL:
      return { ...state, recoveryModalOpen: true, recoveryReason: action.payload || 'unknown' };
    case CLOSE_MEDIA_RECOVERY_MODAL:
      return { ...state, recoveryModalOpen: false };
    case SET_SCREEN_SHARE_INITIATED:
      return { ...state, screenShareInitiated: action.payload };
    case CLEAR_SCREEN_SHARE_INITIATED:
      return { ...state, screenShareInitiated: null };
    case SET_MEDIA_SHARE_COMPLETED:
      return { ...state, mediaShareCompleted: true };
    default:
      return state;
  }
}
